export const getArchitecture = (plan: Plan) => {
  return plan?.is_redis_flex ? 'flex' : 'ram';
};
